import { render, staticRenderFns } from "./SilhouetteEdit.vue?vue&type=template&id=519ff63e&scoped=true&"
import script from "./SilhouetteEdit.vue?vue&type=script&lang=js&"
export * from "./SilhouetteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ff63e",
  null
  
)

export default component.exports